// Which questions a reviewer has changed in Override mode, compared with what the form was seeded
// with (the AI's verdict and reason). Display only - it drives the save bar's count and the outline
// on each edited question. The save itself still sends the whole form (plus the evidence of each
// question whose quotes changed).

import { evidenceChanged } from '../../common/evidenceDraft';

const FIELDS = ['answer', 'score', 'compliance', 'reason'];
const GROUPS = ['compliance', 'quality', 'conduct'];

// Compared as strings: a stored score can be a number while the input hands back a string.
const differs = (before, after) =>
  FIELDS.some((field) => String(before?.[field] ?? '') !== String(after?.[field] ?? ''));

export const changedQuestionKeys = (seed = {}, current = {}, editableSteps = {}, evidenceDrafts = {}) => {
  const changed = new Set();
  GROUPS.forEach((group) => {
    const seeded = seed?.[group] || {};
    Object.entries(current?.[group] || {}).forEach(([key, value]) => {
      if (!(key in seeded) || differs(seeded[key], value)) changed.add(key);
    });
  });
  // A pre-check step correction is a change even when the answer is left alone.
  Object.entries(editableSteps || {}).forEach(([key, steps]) => {
    if (steps && Object.keys(steps).length > 0) changed.add(key);
  });
  // Kept quotes switched off, or lines cited (common/evidenceDraft.js).
  Object.entries(evidenceDrafts || {}).forEach(([key, draft]) => {
    if (evidenceChanged(draft)) changed.add(key);
  });
  return changed;
};
